/**
 * What remains of the route placeholders: the not-found screen. The account and
 * admin screens live in AccountRoute.tsx and AdminRoutes.tsx.
 */
import { useDocumentTitle } from '../lib/documentTitle';

export function NotFoundRoute() {
  useDocumentTitle('Not found');
  return (
    <div className="sheet">
      <div className="masthead">
        <div>
          <h1>Not found</h1>
          <p className="meta">That page does not exist.</p>
        </div>
      </div>
    </div>
  );
}
